<template>
  <form-accordion :title="configTitle" :isTitleUpperCase="false">
    <b-row>
      <div class="form-group col-sm-6">
        <form-read-group-label-input
        :inputLabel="$t('common.routing.message')"
        :inputValue="message"
        ></form-read-group-label-input>
      </div>
      <div class="form-group col-sm-6">
        <form-read-group-label-input
        :inputLabel="$t('common.routing.format_name')"
        :inputValue="format"
        ></form-read-group-label-input>
      </div>
    </b-row>
    <b-row>
      <b-col cols="6" class="form-group" v-if="isEditable">
        <label>
          {{ $t('common.routing.config_type') }}
        </label>
        <select class="form-control" v-model="typeConfig" @change="/*emptyFields*/">
          <option v-for="config in configTypeList" :key="config.id" :value="config.value">
            {{ config.name }}
          </option>
        </select>
      </b-col>
      <b-col cols="6" class="form-group" v-else>
        <form-read-group-label-input
        :inputLabel="$t('common.routing.config_type')"
        :inputValue="configType"
        ></form-read-group-label-input>
      </b-col>
    </b-row>
    <mq-series-configuration-form v-if="typeConfig === 'MQSERIES'" v-model="configMQSeries" :placementMQSeries="placementConfig"></mq-series-configuration-form>
    <web-service-configuration-form v-if="typeConfig === 'WEBSERVICE'" v-model="configWebService" :placementWebService="placementConfig" :prefilledURI="prefilledWebServiceURI"></web-service-configuration-form>
  </form-accordion>
</template>
<script>
import _ from 'lodash'
import backButton from "@/components/common/backButton.vue"
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import MQSeriesConfigurationForm from '@/pages/routing/MQSeriesConfigurationForm.vue'
import WebServiceConfigurationForm from '@/pages/routing/WebServiceConfigurationForm.vue'


export default {
name: 'ConfigSortieForm.vue',
components: {
  'back-button': backButton,
  'form-accordion': FormAccordion,
  'form-read-group-label-input': formReadGroupLabelInput,
  'form-write-group-label-input': formWriteGroupLabelInput,
  'page-outline': PageOutline,
  'mq-series-configuration-form':MQSeriesConfigurationForm,
  'web-service-configuration-form':WebServiceConfigurationForm

},
props: {
  mode: {
  type: String,
    default: 'add'
  },
  id: {
    type: String,
    default: '-1'
  },
  isEditable: {
    type: Boolean,
    default: false
  },
  placementConfig: {
    type: Number,
    default: null
  },
  title: {
    type: String,
    default: ''
  },
  value: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
computed: {
  inputValue: {
    get () {
      return this.value
    },
    set (val) {
      this.$emit('input', val)
    }
  },
  message:{
    get () {
      return this.inputValue.message
    },
    set (val) {
      this.inputValue = {
        id: this.inputValue.id,
        message: val,
        format: this.inputValue.format,
        typeConfig: this.inputValue.typeConfig,
        configMQSeries: this.inputValue.configMQSeries,
        configWebService: this.inputValue.configWebService
      }
    }
  },
  format:{
    get () {
      return this.inputValue.format
    },
    set (val) {
      this.inputValue = {
        id: this.inputValue.id,
        message: this.inputValue.message,
        format: val,
        typeConfig: this.inputValue.typeConfig,
        configMQSeries: this.inputValue.configMQSeries,
        configWebService: this.inputValue.configWebService
      }       
    }
  },
  typeConfig:{
    get () {
      return this.inputValue.typeConfig
    },
    set (val) {
      this.inputValue = {
        id: this.inputValue.id,
        message: this.inputValue.message,
        format: this.inputValue.format,
        typeConfig: val,
        configMQSeries: this.inputValue.configMQSeries,
        configWebService: this.inputValue.configWebService
      }
    }
  },
  configMQSeries:{
    get () {
      return this.inputValue.configMQSeries
    },
    set (val) {
      this.inputValue = {
        id: this.inputValue.id,
        message: this.inputValue.message,
        format: this.inputValue.format,
        typeConfig: this.inputValue.typeConfig,
        configMQSeries: val,
        configWebService: this.inputValue.configWebService
      }
    }
  },
  configWebService:{
    get () {
      return this.inputValue.configWebService
    },
    set (val) {
      this.inputValue = {
        id: this.inputValue.id,
        message: this.inputValue.message,
        format: this.inputValue.format,
        typeConfig: this.inputValue.typeConfig,
        configMQSeries: this.inputValue.configMQSeries,
        configWebService: val,
        sslMode: this.inputValue.configMQSeries
      }
    }
  },
},
data () {
  return {
    certificateConfigList: [],
    config: {},
    configAdded: false,
    configTitle: '',
    configTypeList: [],
    messageConfigList: [],
    prefilledWebServiceURI: this.value.webServiceURI
  }
},
created () {
  this.configTitle = this.title ? this.title : this.$i18n.t('common.global.config_out') + ' ' + this.placementConfig
  this.configTypeList = [
    {
      id: 0,
      name: 'Selectionner un type de configuration...'
    },
    {
      id: 1,
      name: 'MQSeries',
      value: 'MQSERIES'
    },
    {
      id: 2,
      name: 'Web Service',
      value: 'WEBSERVICE'
    },
  ]
  this.getMessageRouting()
},
methods: {
  addConfig(){
    this.configAdded = !this.configAdded
  },
  emptyFields() {
    if(this.typeConfig === 'MQSERIES') {
      this.configWebService = {}
    }
    if(this.typeConfig === 'WEBSERVICE') {
      this.configMQSeries = {}
    } 
  },
  getMessageRouting () {
    this.$engine.routing.message.fetch(
      {}
    ).then(resp => {
      let messageRouting = {}
      messageRouting = resp.data.MessageRouting
      this.updateMessages(messageRouting)
    })
  },
  updateMessages(messageRouting){
    this.messageConfigList = messageRouting
  }
}
}
</script>
